/* eslint-disable */
// Load dependencies
/***************************************************/

var settings = {
	now				: 	"방금",
	seconds			: 	"%d초전",
	minute 			: 	"1분전",
	minutes			: 	"%d분전",
	hour 			: 	"1시간전",
	hours			: 	"%d시간전",
	day 			: 	"1일전",
	days 			: 	"%d일전",
	month 			: 	"1개월전",
	months 			: 	"%d개월전",
	year 			: 	"1년전",
	years 			: 	"%d년전"
};

/***************************************************/

var inWords = function(inpDate){

	// Get time distance from now (in milliseconds)
	var timeDist 	= 	new Date().getTime() - inpDate.getTime();


	// Get time components
	var seconds 	= 	Math.abs(timeDist) 	/ 	1000;
	var minutes 	= 	seconds 			/ 	60;
	var hours 		= 	minutes 			/ 	60;
	var days 		= 	hours 				/ 	24;
	var years 		= 	days 				/ 	365;


	// Get string from number
	function getStrFromNum(string, number){
		return string.replace(/%d/i, number);
	}


	// return words
	var words =
		seconds 	< 	5 		&& 	getStrFromNum(settings.now, 	0					) 	||
		seconds 	< 	30 		&& 	getStrFromNum(settings.seconds, Math.round(seconds)	) 	||
		seconds 	< 	90   	&& 	getStrFromNum(settings.minute, 	1					) 	||
		minutes 	< 	60 		&& 	getStrFromNum(settings.minutes, Math.round(minutes)	) 	||
		minutes 	< 	120 	&& 	getStrFromNum(settings.hour, 	1					) 	||
		hours 		< 	24 		&& 	getStrFromNum(settings.hours, 	Math.round(hours)	) 	||
		hours 		< 	48 		&& 	getStrFromNum(settings.day, 	1					) 	||
		days 		< 	30 		&& 	getStrFromNum(settings.days, 	Math.round(days)	) 	||
		days 		< 	60 		&& 	getStrFromNum(settings.month, 	1					) 	||
		days 		< 	365 	&& 	getStrFromNum(settings.months, 	Math.round(days/30)	) 	||
		years 		< 	1.5 	&& 	getStrFromNum(settings.year, 	1					) 	||
									getStrFromNum(settings.years, 	Math.round(years)	)
	;

	return words;
};


/***************************************************/


var getAgoString = function(input){
	if(input instanceof Date){
		return inWords(input);
	}
	else if(typeof input === "number"){
		return inWords(new Date(input));
	}
	else if(typeof input === "string" && new Date(input).toString() != 'Invalid Date'){
		return inWords(new Date(input));
	}
	else{
		return input; // could not convert
	}
};

/***************************************************/

export default getAgoString;
